import { React, useState } from "react";
import "./Login.css";
import loginImage from "../../../images/environ1.png";
// import { useNavigate } from 'react-router-dom'
import { logUser } from "../../../services/Api";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

const Signin = () => {

  const toast = useToast(); 
  const navigate = useNavigate();
  const initial = {
    uid: "",
    password: "",
  };

  const [user, setUser] = useState(initial);
  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    const data = await logUser(user);
    console.log(data);
    if (data?.data?.status === "success") {
      console.log(data.data.data);
      window.localStorage.setItem("user", JSON.stringify(data.data.data));
      navigate("/events");
    } else {
      toast({
        title: "Sign in",
        description: `${data.data.message}`,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };
  
  const handleKeyDown = (e) => {
    // e.preventDefault();
    console.log(e.key);
    if (e.key === "Enter") {
      console.log("key pressed");
      handleLogin();
    }
  };

  return (
    <div
      className="signin-container"
      onKeyPress={(e) => e.key === "Enter" && handleLogin()}
    >
      <div className="left">
        <img className="sign-in" src={loginImage} alt="signin" />
      </div>
      <div className="right">
        <div className="log-head">Sign In</div>
        <div className="inputs">
          <div className={`input-area `}>
            <div className={`input-label `}>User Name</div>
            <input
              autoFocus
              className={`input-field `}
              type="text"
              name="uid"
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div className="input-area">
            <div className="input-label">Password</div>
            <input
              className="input-field"
              type="password"
              name="password"
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
        <div
          tabIndex={0}
          className="signin-btn"
          onClick={handleLogin}
          onKeyDown={(e) => handleKeyDown(e)}
        >
          <button>Sign In</button>
        </div>
      </div>
    </div>
  );
};

export default Signin;
